import { create } from 'zustand';
import type { OsceStation } from '@/graphql/gql/graphql';
import type { OmitFunctions } from '@/types';
import { createSelectors } from './selector';

interface StationState {
  station: OsceStation | null;
  defaultExpandedKeys: string[];
  preview: boolean;
  stationId: number;
  updateLoading: boolean;
  stationLayout: 'horizontal' | 'vertical';
  setStationLayout: (layout: 'horizontal' | 'vertical') => void;
  reset: () => void;
  setPreview: (val: boolean) => void;
  setStationId: (id: number) => void;
  setStation: (station?: OsceStation) => void;
  setDefaultExpandedKeys: (keys: string[]) => void;
  setUpdateLoading: (loading: boolean) => void;
}

const initialState: OmitFunctions<StationState> = {
  updateLoading: false,
  station: null,
  defaultExpandedKeys: [],
  preview: false,
  stationId: 4,
  stationLayout: 'horizontal',
};

export const stationState = create<StationState>()((set) => ({
  ...initialState,
  reset: () => {
    set(initialState);
  },
  setPreview: (preview) => set({ preview }),
  setStationId: (stationId) => set({ stationId }),
  setStationLayout: (layout) => set({ stationLayout: layout }),
  setStation: (station) => set({ station }),
  setDefaultExpandedKeys: (defaultExpandedKeys) => set({ defaultExpandedKeys }),
  setUpdateLoading: (loading) => set({ updateLoading: loading }),
}));

export const useStationState = () => stationState((state) => state);
export const useStation = createSelectors(stationState);
